declare global {
    interface Window {
        cordova: unknown;
    }
}

/**
 * Hook to detect if app is running in a mobile environment
 * @returns {Object} Object containing mobile environment flags
 * @property {boolean} isCordova - DEPRECATED - Returns true if app is running in mobile
 * @property {boolean} isCapacitor - Returns true if app is running in mobile
 */

export const useCapacitor = () => {
    const isCordova = !!window.cordova;
    const isCapacitor = !!window.cordova;

    return { isCordova, isCapacitor };
};
